import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import DrinkDialog from "~/components/Blocks/DrinkDialog";
import Chip from "@mui/material/Chip";

const DrinkList = (props) => {
    const { drink_list = [], drinkNumber, onlyNonArcohol, selectDrink, reselectDrink } = props;

    const [selectedDrink, setSelectedDrink] = useState("");
    const [select_detail_drink, set_select_detail_drink] = useState(false);

    // ドリンクセット選択ボタンを押す
    const handleClickSelect = (drink_group_data) => {
        setSelectedDrink(drink_group_data.drink_group_id);
        selectDrink(drink_group_data);
    };
    // ドリンクセット再選択ボタンを押す
    const handleClickReselect = () => {
        setSelectedDrink("");
        reselectDrink();
    };

    // ドリンク詳細ポップアップを開く
    const OpenDrinkDetail = (drink_data) => {
        set_select_detail_drink(drink_data);
    };
    // ドリンク詳細ポップアップを閉じる
    const CloseDrinkDetail = () => {
        set_select_detail_drink(false);
    };

    return (
        <React.Fragment>
            <DrinkDialog select_drink={select_detail_drink} handleClose={CloseDrinkDetail} />

            <Grid
                container
                justifyContent="center"
                sx={{
                    background: "#c7baaa3a",
                    minHeight: "29rem",
                    pt: 1,
                    pb: 2,
                }}
            >
                {/* ドリンク選択後のみ表示 */}
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    sx={{
                        display: selectedDrink ? "flex" : "none",
                        m: 2,
                        mb: 0,
                    }}
                >
                    <Grid item>
                        <Button size="small" variant="outlined" onClick={handleClickReselect}>
                            再選択する
                        </Button>
                    </Grid>
                </Grid>

                {/* ドリンクセットのカード */}
                {drink_list
                .filter(drink_group_data => drink_group_data.present_drink_number == drinkNumber)
                .filter(drink_group_data => !onlyNonArcohol || drink_group_data.non_arcohol_flag == "1")
                .map(drink_group_data => (
                    <Card 
                        key={drink_group_data.drink_group_id}
                        sx={{
                            display: !selectedDrink
                                ? "grid"
                                : selectedDrink == drink_group_data.drink_group_id
                                ? "grid"
                                : "none",
                            width: 98*drink_group_data.drink_data.length,
                            ml: "0.25rem",
                            mt: "1rem",
                            mr: "0.25rem",
                            boxShadow: 1,
                            borderRadius: 5,
                        }}
                    >
                        <Typography variant="h6" component="div" sx={{ ml: 2, mt: 1 }}>
                            {drink_group_data.drink_group_name}
                        </Typography>
                        {drink_group_data.non_arcohol_flag == "1" ? (
                            <div>
                                <Chip
                                    variant="outlined"
                                    size="small"
                                    label="ノンアル"
                                    color="success"
                                    sx={{ ml: 2 }}
                                />
                            </div>
                        ) : (
                            ""
                        )}

                        {/* 所属ドリンクのカード */}
                        <Grid
                            container
                            justifyContent="center"
                            sx={{
                                pt: 1,
                                pb: 1,
                            }}
                        >
                            {drink_group_data.drink_data.map((drink) => (
                                <Card
                                    key={drink.drink_id}
                                    sx={{
                                        display: "grid",
                                        width: "90px",
                                        ml: "0.25rem",
                                        mt: "1rem",
                                        mr: "0.25rem",
                                        boxShadow: 1,
                                        borderRadius: 5,
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={drink.image_path}
                                        sx={{ objectFit: "cover", width: "90px", height: "150px" }}
                                    />
                                    <CardContent>
                                        <Typography variant="body2" component="div">
                                            {drink.drink_name}
                                        </Typography>
                                        {drink.non_arcohol_flag == "1" ? (
                                            <>
                                                <Chip
                                                    variant="outlined"
                                                    size="small"
                                                    label="ノンアル"
                                                    color="success"
                                                />
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        <Button
                                            sx={{ marginTop: "auto" }}
                                            size="small"
                                            onClick={() => OpenDrinkDetail(drink)}
                                        >
                                            詳細はこちら
                                        </Button>
                                    </CardContent>
                                </Card> 
                            ))}
                        </Grid> {/* 所属ドリンクのカード */}

                        <ButtonBase
                            size="small"
                            variant="outlined"
                            onClick={() => handleClickSelect(drink_group_data)}
                            sx={{ bgcolor: "primary.main", width: "100%", height: "50px", marginTop: "auto" }}
                        >
                            <Box>選択</Box>
                        </ButtonBase>
                    </Card> 
                ))} {/* ドリンクセットのカード */}
            </Grid>
        </React.Fragment>
    );
};

export default DrinkList;
